declare var JSEncrypt: any;

export class Encryption {
  private encrypt = new JSEncrypt();

  private key1: string = 'MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQBzQSWcWWOfcLZUUgnjaU10';
  private key2: string = 'AgMBAAE =';
  private keyslash: string = 'a4 / D / uZeJEdNW / cNyQTu5p8AIoKg2xBZRRB / 9MYuaz4UpJwKXYUr62WbeOGESmHF';
  private keyslashplus: string = 'AeCt / xeS1qSHdqXVl7 + dBIQaEx9g3BPjBDJsHQw7n03WogluV5at3cqzMU + 0oWuv';
  private keyslashplus2: string = 'tMHZYwMuK7JOQ3zKQeAX84 / cUWjHShLVz6Gh6rCkksDsZiBuns + SzW8OhZsbRkzL';
  private keyplus: string = 'YsGcQ0NXESgKCk094Ijs + xT4uHDImyaL7xVf8pnDfmVmbwpuNEjodaItw1GB05HT';
  private keyplus2: string = 'DC13zS1Tm51o + s4RTaLz4UWPgByMAbzMw3Gr7WW5PuYHC4B8XmDQXiYHCVH09y87';

  public encryptString(text: string) {
    this.encrypt.setPublicKey(this.key1 + this.keyplus + this.keyplus2 + this.keyslash + this.keyslashplus + this.keyslashplus2 + this.key2);
    return this.encrypt.encrypt(text);
  }
}
